var _defs, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1c59c5b6a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.101562 167 L 182.601562 167 L 182.601562 363 L 10.101562 363 Z M 10.101562 167 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac66dbaefa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 190.578125 11.785156 L 365.328125 11.785156 L 365.328125 206.785156 L 190.578125 206.785156 Z M 190.578125 11.785156 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c59c5b6a2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 25.761719 343.277344 L 10.050781 167.402344 L 182.648438 167.402344 L 166.929688 343.253906 L 96.242188 362.808594 Z M 25.761719 343.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 153.464844 332.054688 L 166.90625 181.78125 L 96.351562 181.78125 L 96.351562 347.863281 Z M 153.464844 332.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3bdc0",
    d: "M 96.277344 203.351562 L 42.167969 203.351562 L 47.996094 268.582031 L 96.351562 268.582031 L 96.351562 247.011719 L 67.761719 247.011719 L 65.785156 224.925781 L 96.351562 224.925781 L 96.351562 203.351562 Z M 96.351562 302.960938 L 96.257812 302.988281 L 72.195312 296.5 L 70.664062 279.300781 L 48.960938 279.300781 L 51.992188 313.167969 L 96.253906 325.378906 L 96.351562 325.347656 Z M 96.351562 302.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffafc",
    d: "M 96.277344 268.582031 L 122.886719 268.582031 L 120.441406 296.550781 L 96.339844 303.042969 L 96.339844 325.484375 L 140.636719 313.226562 L 146.570312 247 L 96.351562 247 Z M 149.886719 209.140625 L 150.402344 203.351562 L 96.265625 203.351562 L 96.265625 224.917969 L 148.457031 224.917969 L 148.882812 220.070312 Z M 149.886719 209.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac66dbaefa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 365.300781 11.785156 L 190.605469 11.785156 L 206.023438 186.257812 L 277.953125 206.785156 L 349.886719 186.257812 Z M 365.300781 11.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 277.953125 27.179688 L 277.953125 190.875 L 335.5 174.457031 L 348.347656 27.179688 Z M 277.953125 27.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffafc",
    d: "M 324.710938 52.835938 L 277.953125 52.835938 L 277.953125 73.363281 L 303.132812 73.363281 L 301.589844 93.890625 L 277.953125 93.890625 L 277.953125 114.417969 L 300.5625 114.417969 L 299.019531 137.507812 L 277.953125 144.691406 L 277.953125 166.246094 L 318.546875 152.902344 L 322.140625 93.890625 Z M 324.710938 52.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3bdc0",
    d: "M 277.953125 52.835938 L 277.953125 73.363281 L 232.226562 73.363281 L 230.683594 52.835938 Z M 254.320312 93.890625 L 255.347656 114.417969 L 277.953125 114.417969 L 277.953125 93.890625 Z M 256.375 124.679688 L 235.824219 124.679688 L 237.363281 152.902344 L 277.953125 166.246094 L 277.953125 144.691406 L 256.886719 137.507812 Z M 256.375 124.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlCss);
export default __webpack_public_path__ + "static/media/htmlCss.e8a1eb8791ce658dddb6782c54fb872b.svg";
export { ForwardRef as ReactComponent };